import { FORM_FLOW, FORM_SECTION } from "entities/Form";
import {
  AvailableTimeslotV2,
  BookingModeV2,
  LocalizedOptionV2,
  SpecialtyFlowTypeV2,
} from "entities/FormV2";
import i18n from "i18n/i18n";
import { getFormOrder } from "utils/helper";

export const getLocalizedValueByLanguageV2 = (
  option: LocalizedOptionV2 | undefined,
  language: string
) => {
  if (!option) return;
  if (language === "zh-HK" || language === "zh-TW" || language === "tc")
    return option.nameTc;
  if (language === "zh-CN" || language === "sc") return option.nameSc;
  return option.nameEn;
};

export const getLocalizedValueV2 = (option?: LocalizedOptionV2) =>
  getLocalizedValueByLanguageV2(option, i18n.language);

export const getAvailableTimeslotDisplayLabelV2 = (
  timeSlot: AvailableTimeslotV2,
  language: string
) => {
  const timeLabel =
    language === "zh-CN" || language === "sc"
      ? timeSlot.labelSc
      : language === "zh-HK" || language === "zh-TW" || language === "tc"
      ? timeSlot.labelTc
      : timeSlot.label;
  const siteName =
    language === "zh-CN" || language === "sc"
      ? timeSlot.department.siteNameSc
      : language === "zh-HK" || language === "zh-TW" || language === "tc"
      ? timeSlot.department.siteNameTc
      : timeSlot.department.siteNameEn;

  return `${timeLabel} ${siteName || timeSlot.department.siteNameEn}`;
};

export type SiteAddressTranslationKeyV2 =
  | "bhAddress"
  | "ekmcAddress"
  | "amcAddress";

export const getSiteAddressTranslationKeyV2 = (
  siteCode?: string
): SiteAddressTranslationKeyV2 | undefined => {
  switch (siteCode?.trim().toUpperCase()) {
    case "BH":
      return "bhAddress";
    case "EKMC":
      return "ekmcAddress";
    case "AMC":
      return "amcAddress";
    default:
      return undefined;
  }
};

export const getFormOrderV2 = (
  flow?: FORM_FLOW,
  bookingMode?: BookingModeV2,
  specialtyFlowType?: SpecialtyFlowTypeV2
): FORM_SECTION[] =>
  bookingMode === BookingModeV2.Doctor
    ? [
        FORM_SECTION.DOCTOR,
        FORM_SECTION.SERVICE,
        FORM_SECTION.DATE_TIME,
        FORM_SECTION.PATIENT_FORM,
      ]
    : bookingMode === BookingModeV2.Specialty
    ? specialtyFlowType === SpecialtyFlowTypeV2.ServiceFirst
      ? [
          FORM_SECTION.SPECIALTY,
          FORM_SECTION.SERVICE,
          FORM_SECTION.DOCTOR,
          FORM_SECTION.DATE_TIME,
          FORM_SECTION.PATIENT_FORM,
        ]
      : [
          FORM_SECTION.SPECIALTY,
          FORM_SECTION.DOCTOR,
          FORM_SECTION.SERVICE,
          FORM_SECTION.DATE_TIME,
          FORM_SECTION.PATIENT_FORM,
        ]
    : getFormOrder(flow);
